import type {Expand} from '../types';

import {courseExpandCommon} from '../course';
import {programExpandCommon} from '../program';
import {subtenantExpandCommon} from '../subtenant';
import {userExpandCommon} from '../user';

export const membershipExpandCommon: Expand = {
  membership: [
    ['user_id', {name: 'User not found'}, userExpandCommon],
    ['program_id', {title: 'Program not found'}, programExpandCommon],
    ['course_id', null, courseExpandCommon],
    ['subtenant_id', null, subtenantExpandCommon],
  ],
};
